import { TextInput, email, required, useTranslate } from 'react-admin';
import { useState } from 'react';
import { InputAdornment } from '@mui/material';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import DisactiveIcon from '@/assets/icons/disactive-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

const CustomLoginEmailInput = ({ isRequired = false }) => {
    const [invalidEmail, setInvalidEmail] = useState(false);
    const translate = useTranslate();

    const validateEmailWithLogging = value => {
        let error;
        if (isRequired) {
            error = required()(value) || email()(value);
        } else {
            error = value ? email()(value) : undefined;
        }
        setInvalidEmail(!!error);
        return error;
    };

    return (
        <TextInput
            source='email'
            type='email'
            label={translate('auth.yourBusinessEmail')}
            fullWidth
            validate={validateEmailWithLogging}
            sx={{
                marginTop: '19px',
                '& .MuiInputBase-root': { paddingLeft: '16px' },
                '& .MuiFormHelperText-root': { display: 'none' },
                '& .MuiFormLabel-root': {
                    color: invalidEmail ? `${Palette.red.red400} !important` : 'initial',
                },
                '& .MuiInputLabel-root.MuiFormLabel-filled': {
                    transform: 'translate(14px, -11px) scale(1)',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    transform: 'translate(14px, -11px) scale(1)',
                },
            }}
            InputProps={{
                endAdornment: <InputAdornment position='end'>{invalidEmail ? <DisactiveIcon /> : <ActiveIcon />}</InputAdornment>,
            }}
        />
    );
};

export default CustomLoginEmailInput;
